import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ForgeRunInterface } from "../../../middleware/interfaces/forge/forge-run-interface";

export const ForgeRun = {
  Run: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const forgeRunData: ForgeRunInterface = state.data;
      const url = "./php/forge/forge-runner-queue-proxy.php";
      await axios
        .post(url, forgeRunData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
